import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-primary-50" }
const _hoisted_2 = { class: "container mx-auto px-4 py-8 max-w-6xl" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "text-display-sm font-heading font-bold text-primary-800 mb-6" }, " Community Events ", -1)
const _hoisted_4 = { class: "bg-white rounded-xl border border-primary-200 shadow-soft mb-6" }
const _hoisted_5 = { class: "flex" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5",
  viewBox: "0 0 20 20",
  fill: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M7 3a1 1 0 000 2h6a1 1 0 100-2H7zM4 7a1 1 0 011-1h10a1 1 0 110 2H5a1 1 0 01-1-1zM2 11a2 2 0 012-2h12a2 2 0 012 2v4a2 2 0 01-2 2H4a2 2 0 01-2-2v-4z" })
], -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Event List ")
const _hoisted_8 = {
  key: 0,
  class: "absolute bottom-0 left-0 right-0 h-0.5 bg-accent-600"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
  })
], -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Full Calendar ")
const _hoisted_11 = {
  key: 0,
  class: "absolute bottom-0 left-0 right-0 h-0.5 bg-accent-600"
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "bg-white rounded-xl border border-primary-200 shadow-soft p-4 overflow-hidden" }, [
  /*#__PURE__*/_createElementVNode("iframe", {
    src: "https://calendar.google.com/calendar/embed?height=600&wkst=1&bgcolor=%23ffffff&ctz=America%2FChicago&showCalendars=1&title=Neighborhood%20Events&src=aHBmOXV1dmdobzE3Y3Z2dDhlNmp1NmdjaDhAZ3JvdXAuY2FsZW5kYXIuZ29vZ2xlLmNvbQ&color=%23F6BF26",
    class: "w-full rounded-lg",
    style: {"border":"none"},
    height: "600",
    frameborder: "0",
    scrolling: "no"
  })
], -1)
const _hoisted_15 = [
  _hoisted_14
]

import EventCard from "@/components/events/EventCard.vue";
import { ref, computed } from "vue";
import { useAuthStore } from "@/stores/auth";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const auth = useAuthStore();
const is_staff = computed(() => auth.staff);
const showTab = ref("event_list");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("nav", _hoisted_5, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showTab.value = 'event_list')),
            class: _normalizeClass(["flex-1 flex items-center justify-center gap-2 px-4 py-4 text-sm font-medium transition-colors relative", {
              'text-accent-700': showTab.value === 'event_list',
              'text-primary-500 hover:text-primary-700':
                showTab.value !== 'event_list',
            }])
          }, [
            _hoisted_6,
            _hoisted_7,
            (showTab.value === 'event_list')
              ? (_openBlock(), _createElementBlock("span", _hoisted_8))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (showTab.value = 'calendar')),
            class: _normalizeClass(["flex-1 flex items-center justify-center gap-2 px-4 py-4 text-sm font-medium transition-colors relative", {
              'text-accent-700': showTab.value === 'calendar',
              'text-primary-500 hover:text-primary-700': showTab.value !== 'calendar',
            }])
          }, [
            _hoisted_9,
            _hoisted_10,
            (showTab.value === 'calendar')
              ? (_openBlock(), _createElementBlock("span", _hoisted_11))
              : _createCommentVNode("", true)
          ], 2)
        ])
      ]),
      (showTab.value === 'event_list')
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createVNode(EventCard)
          ]))
        : _createCommentVNode("", true),
      (showTab.value === 'calendar')
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})